import React, { Component } from 'react'
import './style.css'

export default class LoadingWheel extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div class='directory-spinner' style={this.props.visible ? {display:'block'} : {display:'none'}}></div>
        );
    }
}